import React from 'react';

const UsersSalesStaffListPage = React.lazy(() => import('pages/users/sales-staff/list'));

const SalesStaffUserEditPage = React.lazy(() => import('pages/users/sales-staff/edit'));
const SalesStaffUserCreatePage = React.lazy(() => import('pages/users/sales-staff/create'));

const policiesView = [{ resource: 'salesStaffList', action: 'view' }];
const policiesUpdate = [{ resource: 'salesStaffList', action: 'update' }];

export const definitions = [
  {
    index: true,
    policies: policiesView,
    component: <UsersSalesStaffListPage />
  },
  {
    path: 'new',
    policies: policiesUpdate,
    component: <SalesStaffUserCreatePage />
  },
  {
    path: ':userID',
    policies: policiesUpdate,
    component: <SalesStaffUserEditPage />
  }
];
